'use strict';

var $ = require('jquery');

module.exports = function (options) {
  var context = options.context;

  function init() {
    if (context.find('[data-binding="variation-toggle"]').length > 1) {
      context.find('[data-binding="variation-toggle"]').on('click', function () {
        var selectedVariation = $(this);
        context.find('[data-binding="variation-toggle"]').each(function () {
          var currentVariation = $(this);
          if (selectedVariation.is(currentVariation)) {
            currentVariation.parent().toggleClass('closed');
          } else {
            currentVariation.parent().addClass('closed');
          }
        });
      });

      context.find('[data-binding="species-variation"]').addClass('closed');
    }
  }

  return {
    init: init
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/species-variations.js
// module id = 495
// module chunks = 0